import React, { useEffect } from 'react';

import { Banner } from '../Banner';
import { useDocLimitBanner } from './useDocLimitBanner';
import { trackDocLimitBannerShown } from './utils';

export const DocLimitBanner = () => {
  const bannerConfig = useDocLimitBanner();

  useEffect(() => {
    if (!bannerConfig) return;
    trackDocLimitBannerShown();
  }, [bannerConfig]);

  if (!bannerConfig) return null;

  return <Banner {...bannerConfig} />;
};
